import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface FieldInvalidation {
  campo: string;
  observacao?: string;
  /** registroId for cadastro or recadastro, use to scope events to specific record */
  registroId?: string;
  /** 'recadastro' or 'cadastro' so subscribers can filter by type */
  tipo?: 'recadastro' | 'cadastro';
}

@Injectable({ providedIn: 'root' })
export class ValidationBusService {
  private subject = new Subject<FieldInvalidation>();

  emitInvalidation(evt: FieldInvalidation) {
    this.subject.next(evt);
  }

  onInvalidation(): Observable<FieldInvalidation> {
    return this.subject.asObservable();
  }
}
